import { select } from "redux-saga/effects";
import { getUserId } from "@modules/account/selectors";
import * as browserInfo from "browser-info";

export function* prepareEvent(event, payload) {
  const userId = yield select(getUserId);
  const now = new Date().toUTCString();
  const { host, hostname, href, origin, pathname, protocol, port } = window.location;
  event.add("userId", userId);
  event.add("datetime", now);
  event.add("browser", browserInfo());
  event.add("location", { host, hostname, href, origin, pathname, protocol, port });
  event.add("action", payload);
  return event;
}
